import { render, staticRenderFns } from "./DynamicForms.vue?vue&type=template&id=02dd6a6b&scoped=true&"
import script from "./DynamicForms.vue?vue&type=script&lang=js&"
export * from "./DynamicForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd6a6b",
  null
  
)

export default component.exports